var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFindIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86 67.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #231916;\n        stroke-width: 3.23px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-width: 4px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke: #000;\n      }\n\n      .cls-3 {\n        stroke-width: 2px;\n      }\n\n      .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        fill: #231916;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30D9\\u30FC\\u30B9",
    "data-name": "\\u30D9\\u30FC\\u30B9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.86,35.76h-28.25c-.22-.48-.22-1.01-.11-1.58h28.39c.07.54.07.88-.03,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.9,50.79h-28.35c-.16-.45-.15-.97-.02-1.57h28.32c.1.53.11.86.05,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.88,43.19h-28.34c-.14-.41-.14-.86,0-1.43h28.18c.27.41.27.88.15,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.86,13.2h-28.25c-.22-.48-.22-1.01-.11-1.58h28.39c.07.54.07.88-.03,1.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.9,28.23h-28.35c-.16-.45-.15-.97-.02-1.57h28.32c.1.53.11.86.05,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m53.88,20.64h-28.34c-.14-.41-.14-.86,0-1.43h28.18c.27.41.27.88.15,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m11.22,14.09c.44.36.39,1.31-.02,1.78l-8.55.03v35.16c0,.65.24,1.53.42,2.11.73,2.46,3.05,4.1,5.55,4.27,3.19.01,5.51-2.14,6.35-5.25V1s49.46,0,49.46,0v51.67c-.6,3.37-3.07,5.82-6.42,6.45l-50.44-.11c-3.34,0-6.48-3.61-6.49-6.83l-.07-38.08h10.21Zm3.22,43.36h42.66c2.87-.36,5.63-2.57,5.63-5.72l.07-48.93H16.99c-.16.07-.32.46-.36.71v48.62c0,1.69-.9,3.18-1.88,4.36-.29.34-.78.48-.32.95Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.2,
    cy: 38.59,
    r: 12.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 72.04,
    y: 45.38,
    width: 7.02,
    height: 22.63,
    transform: "translate(-18.03 69.52) rotate(-44.69)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.29,
    y1: 35.33,
    x2: 60.22,
    y2: 35.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 44.29,
    y1: 43.36,
    x2: 60.22,
    y2: 43.36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindIcon);
export default __webpack_public_path__ + "static/media/find_icon.9a06415c5d07666df521dac09c849390.svg";
export { ForwardRef as ReactComponent };